<template>
  <b-card>
    <div class="hidden-print">
      <b-row style="margin-top: 10px; margin-bottom: 10px">
        <b-col>
          <date-picker
              v-model="data.startDate"
              lang="ru"
              style="width: 100%"
              :placeholder="$t('certificate.fromDate')"
              valueType="format"
              format="DD-MM-YYYY"/>
        </b-col>
        <b-col>
          <date-picker
              v-model="data.endDate"
              lang="ru"
              style="width: 100%"
              :placeholder="$t('certificate.toDate')"
              valueType="format"
              format="DD-MM-YYYY"/>
        </b-col>
        <b-col>
          <b-input-group class="shodowed-group">
            <b-form-select v-model="data.contractorCategoryId" :options="contractorCategories" :value-field="'id'" :text-field="'name'" size="sm" id="categoryFilter">
              <template slot="first">
                <option :value="null" disabled>
                  {{$t('contragent.search-category')}}
                </option>
              </template>
            </b-form-select>
            <b-input-group-append>
              <b-input-group-addon>
                <b-button type="button" size="sm" variant="outline-default" @click="data.contractorCategoryId=null" v-b-tooltip.hover :title="$t('contragent.clear')">
                  <i class="fa fa-close"/>
                </b-button>
              </b-input-group-addon>
            </b-input-group-append>
          </b-input-group>
        </b-col>
        <b-col align="center">
          <b-button @click="getItems" :disabled="loading" variant="dark" class="fa fa-search mr-2 ml-2"/>
          <vs-dropdown vs-custom-content vs-trigger-click>
            <b-link href.prevent class="card-header-action btn-setting">
              <b-button class="fa fa-th" variant="dark"/>
            </b-link>
            <vs-dropdown-menu class="columns-dropdown">
              <vs-dropdown-item v-for="(ind, i) in fields" :key="i">
                <b-checkbox v-model="ind.visible">{{ind.label}}</b-checkbox>
              </vs-dropdown-item>
            </vs-dropdown-menu>
          </vs-dropdown>
          <download-excel  :data="items" :fields="computedJsonToExcel" :disabled="loading" style="cursor: pointer" class="ml-2 btn btn-outline-primary" name="Отчет № 5">
            <b-spinner v-if="loading" small class="mr-2"/><strong>{{ $t('excel-export.download-excel') }}</strong>
          </download-excel>
        </b-col>
      </b-row>
      <hr class="mt-1">
    </div>
    <b-card-body class="marginPage">
      <b-row class="mt-4">
        <b-col>
          <b-table :items="items" :fields="computedFields" id="gridContainer" :busy="loading" :responsive="true" small bordered show-empty striped hover  no-footer-sorting  label-sort-asc="" label-sort-desc="" label-sort-clear="">
            <template #table-busy>
              <div class="text-center my-2">
                <b-spinner small class="mr-2"/><strong>Loading...</strong>
              </div>
            </template>
            <template #cell(index)="data">
              {{ data.index+1 }}
            </template>
          </b-table>
        </b-col>
      </b-row>
    </b-card-body>
  </b-card>
</template>
<script>
import Multiselect from "vue-multiselect";
import {BTable, VBTable} from "bootstrap-vue";
import {BOverlay} from 'bootstrapVue2';
import UsersService from "../../../services/users.sevice";
import {TokenService} from "../../../services/storage.service";
import ReportService from "./report.service";
import ReferencesService from "@/services/references.sevice";

export default {
  name: "Товарный отчет за период",
  components: {Multiselect, BTable, VBTable,BOverlay},
  data() {
    return {
      items: [],
      contractorCategories:[],
      fields: [
        {key: 'index', label: '№', class: 'text-center', visible: true},
        {key: 'contragentName', label: this.$t('Контрагент'), class: 'text-center', visible: true,sortable: true},
        {key: 'remainingOfDocument', label: this.$t('Количество Документов'), class: 'text-center', visible: true,sortable: true},
        {key: 'allPriceEur', label: this.$t('По продажной цене'), class: 'text-center', visible: true,sortable: true},
        {key: 'allPriceUzs', label: this.$t('По приходной цене'), class: 'text-center', visible: true,sortable: true},
      ],
      loading: false,
      groupsList:[],
      data:{
        startDate:'',
        endDate:'',
        contractorCategoryId:null
      }
    };
  },
  methods: {
    excelExport1(tableID, filename = '') {
      var uri = 'data:application/vnd.ms-excel;base64,',
          template = '<html xmlns:o="urn:schemas-microsoft-com:office:office" xmlns:x="urn:schemas-microsoft-com:office:excel" xmlns="http://www.w3.org/TR/REC-html40"><head><!--[if gte mso 9]><xml><x:ExcelWorkbook><x:ExcelWorksheets><x:ExcelWorksheet><x:Name>{worksheet}</x:Name><x:WorksheetOptions><x:DisplayGridlines/></x:WorksheetOptions></x:ExcelWorksheet></x:ExcelWorksheets></x:ExcelWorkbook></xml><![endif]--></head><body><table>{table}</table></body></html>',
          base64 = function(s) {
            return window.btoa(unescape(encodeURIComponent(s)))
          },
          format = function(s, c) {
            return s.replace(/{(\w+)}/g, function(m, p) {
              return c[p];
            })
          }
      var toExcel = document.getElementById(tableID).innerHTML;
      var ctx = {
        worksheet: name || '',
        table: toExcel
      };
      var link = document.createElement("a");
      link.download = `${filename}.xls`;
      link.href = uri + base64(format(template, ctx))
      link.click();
    },
    print() {
      window.print();
    },
    getGroup(){
      ReportService.getDepGroup().then(res=>{
        this.groupsList = res.data
      }).catch((e)=>{
        this.$vs.notify({
          title: e.message,
          color: 'danger',
          icon: 'close',
          position: 'top-right'
        });
      })
    },

    async getItems() {
      this.loading = true
      this.items = []
      if (this.data.startDate !== "" && this.data.endDate !== "" ) {
        ReportService.getReportSearch(this.data).then(res => {
          this.items = res.data
          this.loading = false
        }).catch(e => {
          this.loading = false
          this.$vs.notify({
            title: e.message,
            color: 'danger',
            icon: 'close',
            position: 'top-right'
          });
        })
            .finally(()=>{
              this.loading = false
            })
      } else {
        if (this.startRegDate !== "" && this.endRegDate !== ""){
          this.loading = false
          this.$vs.notify({
            text: "Выберите даты прихода",
            color: "warning",
            icon: "close",
            position: "top-right"
          });
          return 0;
        }else {
          this.loading = false
          this.$vs.notify({
            text: "Выберите даты продажи",
            color: "warning",
            icon: "close",
            position: "top-right"
          });
          return 0;
        }
      }
    }
  },
  created() {
    ReferencesService.getReferenceChildren('CONTRAGENT_CATEGORY').then(res => {
      this.contractorCategories = res.data
    }).catch(e => {
      this.$vs.notify({
        title: e.message,
        color: 'danger',
        icon: 'close',
        position: 'top-right'
      });
    })
  },
  computed: {
    computedJsonToExcel(){
      let visibleFields = {};
      this.fields.forEach(t =>{
        if (t.visible === true){
          visibleFields[t.label] = t.key;
        }
      })
      return visibleFields;
    },
    computedFields() {
      let tmp = []
      this.fields.forEach(t => {
        if (t.visible)
          tmp.push(t)
      })
      return tmp
    },

  },
  watch: {}
}
</script>

<style scoped>

@page  {
  margin: 1cm;
}

@media print {
  .hidden-print {
    display: none;
  }
  .marginPage {
    margin: 0 30px 0 40px;
  }
}
</style>
